import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from './../../../Common/Components/breadcrumb/breadcrumb.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { AddNewSequenceComponent } from './add-new-sequence/add-new-sequence.component';
import { CommonModule } from '@angular/common';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FormsModule } from '@angular/forms';
import { DataGridComponent } from './../../../Common/Components/data-grid/data-grid.component';
import { ApiService } from './../../../Services/api.service';
import { ConfirmPopupComponent } from './../../../Common/Components/confirm-popup/confirm-popup.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { SpinnerComponent } from '../../../Common/Components/spinner/spinner.component';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { UppercaseDirective } from "../../../Common/Components/pipe/UpperCasePipe/uppercase.pipe";

@Component({
  selector: 'app-sequence-dim',
  standalone: true,
  imports: [ NzButtonModule, NzDrawerModule, DataGridComponent, NzDropDownModule, SpinnerComponent,
    AddNewSequenceComponent, FormsModule, CommonModule, NzInputModule, NzIconModule, ConfirmPopupComponent, UppercaseDirective],
  templateUrl: './sequence-dim.component.html',
  styleUrl: './sequence-dim.component.scss'
})
export class SequenceDimComponent implements OnInit {
  constructor(public apiService: ApiService) { }
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;

  linkDrawer: boolean = false;
  activeTab: string = "Dimension 1";
  dimArrData: any = [];
  activeDim: string = "";
  garmentTypes: any = [];
  selectedIds = new Set<number>();
  showModal: boolean = false;
  reOrderTableRows: boolean = false;
  dataLoaded: boolean = false;
  reOrderedList: any = [];
  searchText: string = '';
  dimArrList = [
    {
      id: 1, name: "Dimension 1", type: "dim1", clicked: true
    },
    {
      id: 2, name: "Dimension 2", type: "dim2", clicked: false
    }
  ];
  breadcrumbs: Array<{ label: string, url: any }> = [{
    label: "Sorting Sizes",
    url: ""
  }];
  dimColumns = [
    {
      field: 'uniqueId',
      header: '',
      type: "checkbox"
    },
    {
      field: 'dim',
      header: 'Dimension 1'
    },
    {
      field: 'longDesc',
      header: 'Description',
      editable: true
    },
    {
      field: 'garmentType',
      header: 'GarmentType',
      type: "select",
      editable: true
    },
    {
      field: '',
      header: 'Action',
      icons: ['edit', 'delete'],
      type: 'icon',
      showIcons: true
    }];
  originalDimArrData: any[] = [];
  pageSize: number = 50;
  private scrollSubject = new Subject<void>();
  private scrollSubscription!: Subscription;



  ngOnInit(): void {
    this.dataLoaded = false;
    this.getGarmentTypes();
    this.handleTab(this.dimArrList[0]);
    this.scrollSubscription = this.scrollSubject
      .pipe(debounceTime(200))
      .subscribe(() => {
        this.loadNextBatch();
      });
  }

  onlyAlphanumeric(event: KeyboardEvent) {
    const key = event.key;

    const isControlKey = [
      'Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ].includes(key);

    if (isControlKey) {
      return;
    }

    const isAlphanumeric = /^[a-zA-Z0-9]$/.test(key);

    if (!isAlphanumeric) {
      event.preventDefault();
    }
  }

  onTableScroll(event: any) {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (atBottom) {
      this.scrollSubject.next(); // Push to the subject
    }
  }

  loadNextBatch() {
    if (this.dimArrData.length < this.originalDimArrData.length) {
      const nextBatch = this.originalDimArrData.slice(
        this.dimArrData.length,
        this.dimArrData.length + this.pageSize
      );
      // Use spread to trigger Angular Change Detection
      this.dimArrData = [...this.dimArrData, ...nextBatch];
    }
  }

  handleTab(tab: any) {
    this.dimArrList.map(node => {
      if (node.id == tab.id) {
        node.clicked = true;
        this.activeTab = node.name;
        this.activeDim = node.type;
        this.dimColumns[1].header = this.activeDim == 'dim1' ? 'Dimension 1' : 'Dimension 2';
        this.searchText = "";
        this.reOrderTableRows = false;
        this.getDimDetails();
      }
      else {
        node.clicked = false;
      }
    });
  }

  getDimDetails() {
    this.dataLoaded = true;
    this.apiService.getDimList(this.activeDim).subscribe(response => {
      this.dataLoaded = false;
      this.originalDimArrData = response;
      this.originalDimArrData = this.originalDimArrData instanceof Array ? this.originalDimArrData : [];
      this.originalDimArrData.map((node: any) => {
        Object.assign(node, { uniqueId: node.dim + "_" + node.garmentType, oldGarmentType: node.garmentType })
      });
      if (this.originalDimArrData.length > 0) {
        this.dimArrData = this.originalDimArrData.slice(0, this.pageSize);
      }
    }, err => {
      this.dataLoaded = false;
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  getGarmentTypes() {
    this.apiService.getGarmentTypes().subscribe(response => {
      this.garmentTypes = response.data;
    })
  }

  deAssociate() {
    this.showModal = true;
  }

  onDeleteConfirm(): void {
    this.showModal = false;
    const deleteList = [...this.selectedIds];
    this.prepareDeleteData(deleteList);
  }

  prepareDeleteData(deleteList: any[]) {
    // Ensure we have arrays to compare
    if (!deleteList || deleteList.length === 0 || !this.dimArrData) return;

    const deleteDimList: any = [];

    this.originalDimArrData.forEach((node: any) => {
      // 1. Explicitly build the expected lookup key format matching '036_'
      const dimPart = node.dim !== undefined && node.dim !== null ? String(node.dim).trim() : '';
      const garmentPart = node.garmentType !== undefined && node.garmentType !== null ? String(node.garmentType).trim() : '';
      const calculatedKey = `${dimPart}_${garmentPart}`;

      // 2. Check if the incoming deleteList contains the node uniqueId OR the freshly calculated key
      const hasMatch = deleteList.includes(node.uniqueId) || deleteList.includes(calculatedKey);

      if (hasMatch) {
        // 3. Keep the payload property structures valid even with empty string data
        let formatData = {
          "dim": node.dim,
          // If oldGarmentType is missing or empty string, preserve it cleanly
          "garmentType": (node.oldGarmentType !== undefined && node.oldGarmentType !== null)
            ? node.oldGarmentType
            : garmentPart,
          "oldGarmentType": "",
          "longDesc": node.longDesc ?? "",
          "updateType": "DELETE"
        };
        deleteDimList.push(formatData);
      }
    });

    if (deleteDimList.length > 0) {
      this.postDataAPI(deleteDimList);
    } else {
      // Debug helper to trace exact structural values if nothing caught
      console.error("Match failed. Values checked:", this.dimArrData.map((n: any) => ({
        nodeUniqueId: n.uniqueId,
        calculated: `${n.dim}_${n.garmentType}`
      })));
    }
  }

  deleteRow(data: any) {
    this.prepareDeleteData([data.uniqueId]);
  }

  onDeleteCancel(): void {
    this.showModal = false;
  }

  postDataAPI(dimPostArr: any) {
    this.apiService.postDimData(dimPostArr, this.activeDim).subscribe(response => {
      this.apiService.createNotification('success', response?.message);
      this.ngOnInit();
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  selectedRows(selectedIds: any) {
    this.selectedIds = selectedIds;
  }

  updateRow(data: any) {
    let dimPostArr: any = [];
    dimPostArr.push({
      "dim": data.dim,
      "garmentType": data.garmentType,
      "oldGarmentType": data.oldGarmentType,
      "longDesc": data.longDesc,
      "updateType": "UPDATE"
    });
    this.postDataAPI(dimPostArr);
  }

  getReorderedList(data: any) {
    this.reOrderedList = data;
  }

  saveReorderedList() {
    let reOderedArray: any = [];
    this.reOrderedList.map((node: any) => {
      reOderedArray.push(node.dim + "#" + node.garmentType)
    });

    if (reOderedArray.length > 0) {
      this.apiService.postSequenceDim(reOderedArray, this.activeDim).subscribe(response => {
        this.apiService.createNotification('success', response?.message);
        this.getDimDetails();
        this.reOrderTableRows = false;
      }, err => {
        this.apiService.createNotification('error', err?.error?.message);
      })
    }
  }

  searchDimValue(searchValue: string) {
    this.dataGridComponent.searchData(searchValue, 'dim', this.originalDimArrData);
  }

  showReorderRows() {
    this.searchText = "";
    this.searchDimValue('');
    this.reOrderTableRows = !this.reOrderTableRows;
    if (this.reOrderTableRows) {
      this.dimArrData = [...this.originalDimArrData];
    }
  }

  cancelReorder() {
    this.reOrderTableRows = !this.reOrderTableRows;
    this.dimArrData = this.originalDimArrData.slice(0, this.pageSize);
  }

  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }
}
